import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ConfirmationFormService } from './../confirmation-form.service';
import { ApiConstant } from './../../../utils/api-constant/api-constant.service';
import { PlatformService } from './../../../services/platform.services';

// Models

import { CancelStatus } from '../shared/models/cancel-status.model';

// Constants

import { CANCEL_STATUS } from '../shared/constants/cancel-status';
import { MODAL_STATUS } from '../shared/constants/modal';
export class ConfirmationIndexService {
public dataStore: Observable<any>;
private update: BehaviorSubject<any>;
private store;
/**
 * @param {?} platformService
 * @param {?} router
 * @param {?} fb
 * @param {?} http
 * @param {?} api
 * @param {?} parentService
 */
constructor(
private platformService: PlatformService,
private router: Router,
private fb: FormBuilder,
private http: HttpClient,
private api: ApiConstant,
private parentService: ConfirmationFormService,
  ) {
    // main store
    this.store = {
      profile: null,
      // isCancel property is to show reason list why user want to cancel loan on tunaiku
      isCancel: false,
      rejReasonsList: [],
      cancelForm: null,
      isBusy: false,
      modal: null,
      // Status cancel is the value if loan user is accepted, not accepted, pending or not exist after sending cancel loan
      // And the value is from API
      statusCancel: CANCEL_STATUS.NOT_EXIST,
      isFetching: false,
    };

    // main function for dispatcher
    this.update = <BehaviorSubject<any>>new BehaviorSubject({});
    this.dataStore = this.update.asObservable();
    this.update.next(this.store);
  }
/**
 * @return {?}
 */
public buildForm() {
    const /** @type {?} */ form = {
      reasonEnum: ['', [Validators.required]],
    };
    this.setStore({
      cancelForm: this.fb.group(form),
    });
    this.store.cancelForm.valueChanges.subscribe(res => {});
  }
/**
 * @param {?} obj
 * @return {?}
 */
public setStore(obj: any) {
    const /** @type {?} */ data = ( /** @type {?} */((<any>Object))).assign(this.store, obj);
    this.update.next(data);
  }
/**
 * @return {?}
 */
public getRejReasonsList() {
    this.http.get(`${this.api.apiURL}/loan/reject/reason`).subscribe(res => {
      this.setStore({
        rejReasonsList: res,
      });
    });
  }
/**
 * @return {?}
 */
public cancelLoan() {
    this.setStore({
      isCancel: true,
    });
  }
/**
 * @return {?}
 */
public nextForm() {
    this.setStore({
      isCancel: false,
    });
    this.parentService.nextStep();
  }
/**
 * @return {?}
 */
public closeModal() {
    this.setStore({
      modal: null,
    });
  }
/**
 * @return {?}
 */
public closeSuccessModal() {
    this.setStore({
      modal: null,
    });

    if (this.platformService.isBrowser) {
      location.reload();
    }
  }
/**
 * @return {?}
 */
private getSingleStatusCancelLoan() {
    const /** @type {?} */ headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Auth-Token': this.store.profile,
      }),
    };

    this.http
      .get(
        `${this.api.apiURL}/loan/reject?loanId=${this.store.loan.id}`,
        headers,
      )
      .subscribe(
        (res: CancelStatus) => {
          // If the status we receive from backend is not_accepted we show user the modal which is to inform user to call CS
          // Also when we receive status cancel is same as with previous value, we dont have to show the modal
          if (res.status === CANCEL_STATUS.NOT_ACCEPTED) {
            this.setStore({
              statusCancel: res.status,
              isFetching: false,
              modal:
                res.status === this.store.statusCancel
                  ? null
                  : MODAL_STATUS.FAILED_TO_CANCEL,
            });
          }
          this.setStore({
            statusCancel: res.status,
            isFetching: false,
          });
        },
        (err: HttpErrorResponse) => {
          // Why do we check if err status code 400 and status cancel not_exists ?
          // Because backend will return status code not_exist with error response status code 400
          if (
            err.status === 400 &&
            err.error.status === CANCEL_STATUS.NOT_EXIST
          ) {
            this.setStore({
              statusCancel: err.error.status,
              isFetching: false,
            });
          } else {
            this.setStore({
              isFetching: false,
              modal: MODAL_STATUS.FAILED,
            });
          }
        },
      );
  }
/**
 * @return {?}
 */
public checkStatusCancel(): void {
    this.setStore({
      isFetching: true,
    });
    this.getSingleStatusCancelLoan();
  }
/**
 * @return {?}
 */
public sentCancelLoan() {
    const /** @type {?} */ headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Auth-Token': this.store.profile,
      }),
    };

    const /** @type {?} */ req = {
      loanId: this.store.loan.id,
      reasonEnum: this.store.cancelForm.value.reasonEnum,
    };

    this.http.post(`${this.api.apiURL}/loan/reject`, req, headers).subscribe(
      (res: CancelStatus) => {
        this.setStore({
          statusCancel: res.status,
          isCancel: false,
        });
      },
      (err: HttpErrorResponse) => {
        if (err.status === 500) {
          this.setStore({
            modal: MODAL_STATUS.ERROR,
          });
        } else {
          this.setStore({
            modal: MODAL_STATUS.FAILED,
          });
        }
      },
    );
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: PlatformService, },
{type: Router, },
{type: FormBuilder, },
{type: HttpClient, },
{type: ApiConstant, },
{type: ConfirmationFormService, },
];
}

function ConfirmationIndexService_tsickle_Closure_declarations() {
/** @type {?} */
ConfirmationIndexService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConfirmationIndexService.ctorParameters;
/** @type {?} */
ConfirmationIndexService.prototype.dataStore;
/** @type {?} */
ConfirmationIndexService.prototype.update;
/** @type {?} */
ConfirmationIndexService.prototype.store;
/** @type {?} */
ConfirmationIndexService.prototype.platformService;
/** @type {?} */
ConfirmationIndexService.prototype.router;
/** @type {?} */
ConfirmationIndexService.prototype.fb;
/** @type {?} */
ConfirmationIndexService.prototype.http;
/** @type {?} */
ConfirmationIndexService.prototype.api;
/** @type {?} */
ConfirmationIndexService.prototype.parentService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
